import { render, staticRenderFns } from "./drawer_list.vue?vue&type=template&id=521d7604&scoped=true&"
import script from "./drawer_list.vue?vue&type=script&lang=js&"
export * from "./drawer_list.vue?vue&type=script&lang=js&"
import style0 from "./drawer_list.vue?vue&type=style&index=0&id=521d7604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d7604",
  null
  
)

export default component.exports